import "./Construction.css"
import Product1 from "../Components/Product1"

import Construction1 from "../images/ci1.jpg"
import Construction2 from "../images/ci2.jpg"
import Construction3 from "../images/ci3.jpg"
import Construction4 from "../images/ci4.jpg"
import Construction5 from "../images/ci5.jpg"
import Construction6 from "../images/ci6.jpg"
import Construction7 from "../images/ci7.jpg"
import Construction8 from "../images/ci8.jpg"
import Construction9 from "../images/tooladd.jpg"

export default function Construction() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Construction9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="const1" prdName="CUTTER" img={Construction1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="const2" prdName="DIGGER" img={Construction2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1  id="const3"prdName="SITE_VIEW" img={Construction3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="const4" prdName="HAMMER" img={Construction4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="const5" prdName="SCREW_DRIVERS" img={Construction5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="const6" prdName="JACK" img={Construction6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="const7" prdName="WIRE" img={Construction7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="const8" prdName="CUTTER" img={Construction8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}